import { Chip, Tooltip } from "@mui/material";
import { ExternalLink } from "lucide-react";
import { Button } from "./Button";
import { useAuth } from "./contexts/AuthContext";
import { DEMO_BOOKING_URL } from "../utils/agencyFeatures";

export function TrialBanner() {
  const { user } = useAuth(); const plan = user?.agencyPlan;
  if (!plan || !["agency_admin", "consultant"].includes(user?.role)) return null;
  const label = plan.is_trial
    ? `Prueba gratuita · ${plan.days_remaining} días`
    : `Plan Free · ${plan.editable_clients ?? 0}/${plan.max_clients || 3} con acceso completo`;
  const tooltip = plan.is_trial
    ? "Al terminar tendrás acceso completo a 3 clientes; los demás quedarán en solo lectura."
    : `${plan.active_clients || 0} clientes visibles en total`;
  return (
    <>
      <Tooltip title={tooltip} arrow>
        <Chip size="small" color={plan.is_trial ? "primary" : "default"} variant="outlined" label={label}
          sx={{ display: { xs: "none", md: "inline-flex" }, fontWeight: 500, mr: 0.5 }} />
      </Tooltip>
      {plan.is_trial && (
        <Button
          size="sm"
          href={DEMO_BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          endIcon={<ExternalLink size={14} />}
          sx={{ display: { xs: "none", sm: "inline-flex" }, flexShrink: 0, whiteSpace: "nowrap", mr: 0.5 }}
        >
          Reservar demo
        </Button>
      )}
    </>
  );
}
